import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
    apiKey: "AIzaSyD8pmLucRFzgEpas8vZRFyP8MczXnxlf-Q",
    authDomain: "skillsync-c1b7b.firebaseapp.com",
    projectId: "skillsync-c1b7b",
    storageBucket: "skillsync-c1b7b.firebasestorage.app",
    messagingSenderId: "1040915805664",
    appId: "1:1040915805664:web:e1c7bfd81e0b4e4309a785"
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);

export { db };
